import React, { Component } from 'react';
import MobileHeader from '../components/MobileHeader/MobileHeader';

import Immutable, {Range} from 'immutable';
import _ from 'lodash';
import { firebaseRoot } from './../utils/firebase-utils';
import ReactFireMixin from 'reactfire';
import { Router, Route, Link } from 'react-router';
import TouchLink from '../components/TouchLink';

const Book = React.createClass({
    mixins: [ReactFireMixin],

    getInitialState: function () {
        return {
            book: null,
            exercises: null
        };
    },

    loaded() {
        if (!this['_onLoadedCalled'] && this.props.onLoaded) {
            this._onLoadedCalled = true;
            this.props.onLoaded();
        }
    },

    componentWillMount: function () {
        this.bindAsObject(firebaseRoot.child('content/books').child(this.props.params.bookId), "book");
        this.bindAsArray(firebaseRoot.child('content/exercises').child(this.props.params.bookId), "exercises");
    },

    render: function () {
        if (!this.state.book) {
            return <div>Ops, något gick fel här!</div>;
        }

        if (!this.state.exercises) {
            return <div>Denna bok har ännu inget innehåll inlagt i Albert.</div>
        }

        this.loaded();

        return (
            <div className="screen-wrap">
                <MobileHeader
                    lessonId={this.props.params.lessonId}
                    problemId={this.props.params.problemId}
                    bookId={this.props.params.bookId}
                    type='default'
                    // Don't show the back button on the root screen.
                    backButton={this.props.location && this.props.location.pathname.length > 1}
                />
                <div className="screen-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-xs-12">
                                <h1>Innehållsförteckning</h1>
                                <div className="">
                                    {this.state.exercises.map(chapter => {

                                        return (
                                            <div key={chapter['.key']} className="tab1">
                                                chapter{chapter['.key']}{
                                                _.map(chapter, (subchapter, subchapterKey) => {
                                                    if (subchapterKey == '.key') {
                                                        return null;
                                                    }
                                                    return (
                                                        <div key={subchapterKey} className="tab2">
                                                            subChapter{subchapterKey} {
                                                            _.map(subchapter, (exercise, exerciseKey) => {

                                                                return (
                                                                    <div key={exerciseKey} className="tab3">
                                                                        <TouchLink
                                                                            className="book-problem" key={exerciseKey}
                                                                            to={`/book/${this.state.book['.key']}/${chapter['.key']}/${subchapterKey}/${exerciseKey}`}>
                                                                            {exerciseKey}
                                                                        </TouchLink>
                                                                    </div>);
                                                            })}</div>);
                                                })}</div>);

                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
});

export default Book;



/** WEBPACK FOOTER **
 ** ./src/screens/Book.js
 **/